<script setup lang="ts">
import type { Table } from '@tanstack/vue-table';
import type { Campaign } from './schema';
import { computed } from 'vue';

// Usando os componentes shadcn que você baixou
import { Button } from 'dashboard/components-shadcn/new-york/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'dashboard/components-shadcn/new-york/ui/dropdown-menu';

interface DataTableViewOptionsProps {
  table: Table<Campaign>;
}

const props = defineProps<DataTableViewOptionsProps>();

const columns = computed(() => {
  const cols = props.table.getAllColumns().filter(
    column =>
      typeof column.accessorFn !== 'undefined' && column.getCanHide(),
  );

  return cols;
});
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button
        variant="outline"
        size="sm"
        class="h-8 border-b border-n-slate-6  bg-n-slate-6 hover:bg-n-slate-4 dark:hover:bg-slate-4 transition-colors mt-2"
      >
        <span class="i-lucide-sliders-horizontal mr-2 h-4 w-4 text-n-slate-11"></span>
        <span class="text-n-slate-12">Visualizar</span>
      </Button>
    </DropdownMenuTrigger>

    <DropdownMenuContent
      align="end"
      class="w-[180px] bg-n-slate-1 border-n-slate-6 shadow-lg rounded-lg overflow-hidden"
    >
      <DropdownMenuLabel class="text-n-slate-12 font-medium px-3 py-2">
        Alternar colunas
      </DropdownMenuLabel>

      <DropdownMenuSeparator class="bg-n-slate-4" />

      <div class="p-1">
        <DropdownMenuCheckboxItem
          v-for="column in columns"
          :key="column.id"
          class="capitalize"
          :model-value="column.getIsVisible()"
          @update:model-value="(value) => column.toggleVisibility(!!value)"
        >
          {{ column.columnDef.name || (typeof column.columnDef.header === 'string' ? column.columnDef.header : column.id) }}
        </DropdownMenuCheckboxItem>
      </div>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

